import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Map, { Marker, Popup } from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import Navbar from "../components/Navbar";
import api from "../api";

export default function CityMap() {
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hoveredCity, setHoveredCity] = useState(null); // for popup
  const navigate = useNavigate();
  const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;

  // Fetch cities from backend
  useEffect(() => {
    const fetchCities = async () => {
      try {
        const res = await api.get("/housing/cities/");
        setCities(res.data);
      } catch (err) {
        console.error("Failed to fetch cities", err);
      } finally {
        setLoading(false);
      }
    };
    fetchCities();
  }, []);

  if (!MAPBOX_TOKEN) return <p>Mapbox token is missing!</p>;

  return (
    <div className="min-h-screen">
      <Navbar />
      <div className="p-6">
        <h1 className="text-3xl font-bold mb-6 text-gray-800">
          Living Wage Scrapers
        </h1>

        <div className="h-[600px] w-full rounded-lg overflow-hidden shadow relative">
          {/* Spinner overlay */}
          {loading && (
            <div className="absolute inset-0 flex items-center justify-center bg-white/70 z-10">
              <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
            </div>
          )}

          <Map
            initialViewState={{
              longitude: 10, // central Europe longitude
              latitude: 50,  // central Europe latitude
              zoom: 3.5,     // default zoom in Europe
              minZoom: 2,    // cannot zoom out too far
              maxZoom: 12,   // optional: limit how far user can zoom in
              pitch: 0,
              bearing: 0,
            }}
            style={{ width: "100%", height: "100%" }}
            mapStyle="mapbox://styles/mapbox/streets-v11"
            mapboxAccessToken={MAPBOX_TOKEN}
          >
            {cities
              .filter((c) => c.latitude != null && c.longitude != null)
              .map((city) => (
                <Marker
                  key={city.id}
                  longitude={city.longitude}
                  latitude={city.latitude}
                  anchor="bottom"
                >
                  <div
                    className={`w-4 h-4 rounded-full cursor-pointer ${
                      city.is_available
                        ? "bg-green-800 opacity-60 hover:opacity-100"
                        : "bg-red-500 opacity-60 hover:opacity-100"
                    }`}
                    onMouseEnter={() => setHoveredCity(city)}
                    onMouseLeave={() => setHoveredCity(null)}
                    onClick={() => navigate(`/cities/${city.id}`)}
                  ></div>
                </Marker>
              ))}

            {/* Popup showing city name above the marker */}
            {hoveredCity && (
              <Popup
                longitude={hoveredCity.longitude}
                latitude={hoveredCity.latitude}
                anchor="bottom"
                closeButton={false}
                closeOnClick={false}
                offset={[0, -10]} // moves popup above dot
              >
                <span className="text-sm font-medium">{hoveredCity.name}</span>
              </Popup>
            )}
          </Map>
        </div>
      </div>
    </div>
  );
}
